<div class="dialog-container">
  <h2 mat-dialog-title>{{ 'interviews.declineModal.title' | translate }}</h2>

  <mat-dialog-content>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>{{ 'interviews.declineModal.reason' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedReason" required>
        <mat-option *ngFor="let r of reasons" [value]="r">
          {{ 'interviews.declineModal.reasons.' + r | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%; margin-top: 0.75rem;">
      <mat-label>{{ 'interviews.declineModal.notes' | translate }}</mat-label>
      <textarea
        matInput
        [(ngModel)]="notes"
        rows="4"
        maxlength="1000"
        [placeholder]="'interviews.declineModal.notesPlaceholder' | translate">
      </textarea>
      <mat-hint align="end">{{ notes.length }}/1000</mat-hint>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="gap: 0.5rem; padding: 1rem 0 0;">
    <app-button
      [label]="'common.cancel' | translate"
      (click)="cancel()"
      [size]="ButtonSize.LARGE"
      [state]="ButtonState.REGULAR"
      [type]="ButtonType.SECONDARY">
    </app-button>
    <app-button
      [label]="'interviews.declineModal.confirm' | translate"
      (click)="confirm()"
      [size]="ButtonSize.LARGE"
      [state]="selectedReason ? ButtonState.REGULAR : ButtonState.DISABLED"
      [type]="ButtonType.PRIMARY">
    </app-button>
  </mat-dialog-actions>
</div>